export default __webpack_public_path__ + "static/media/stock.b6284712.jpeg";